import { render } from "./SVGWarning.vue?vue&type=template&id=ef2f42e0"
import script from "./SVGWarning.vue?vue&type=script&lang=js"
export * from "./SVGWarning.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__